import * as React from "react";
import { Typography } from "@mui/material";

export function CervinoHeaderText({
                                      headerText,
                                      children,
                                      align = "center",
                                      color = "inherit",
                                      component = "h1",
                                      maxWidth = "100%",
                                      sx,
                                  }) {
    return (
        <Typography
            component={component}
            sx={{
                fontWeight: 900,
                textAlign: align,
                color,
                maxWidth,
                mx: align === "center" ? "auto" : 0,
                fontSize: { xs: "2.5rem", sm: "5rem", md: "7rem" },
                letterSpacing: { xs: "0.02em", md: "0.04em" },
                ...sx,
            }}
        >
            {children ?? headerText}
        </Typography>
    );
}
